import { defineMessages } from 'react-intl';
export var messages = defineMessages({
  address: {
    id: 'update-profile-modal.address',
    defaultMessage: 'Address'
  },
  copy: {
    id: 'update-profile-modal.copy',
    defaultMessage: 'This venue requires the following information to reserve your spot. Please take a minute to update your profile. You’ll only need to do this once!'
  },
  cta: {
    id: 'update-profile-modal.cta',
    defaultMessage: 'Update my profile'
  },
  dateOfBirth: {
    id: 'update-profile-modal.dateOfBirth',
    defaultMessage: 'Date of birth'
  },
  emergencyContact: {
    id: 'update-profile-modal.emergencyContact',
    defaultMessage: 'Emergency contact'
  },
  heading: {
    id: 'update-profile-modal.heading',
    defaultMessage: 'Update your profile information'
  },
  phone: {
    id: 'update-profile-modal.phone',
    defaultMessage: 'Phone number'
  }
});